import script from "./SguReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SguReport.vue?vue&type=script&setup=true&lang=js"

import "./SguReport.vue?vue&type=style&index=0&id=e7988e1e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7988e1e"]])

export default __exports__